export default function ChevronRight({
  fill = 'white',
  width,
  height
}: {
  fill?: 'white' | 'black';
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width || 27}
      height={height || 24}
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-chevron flex shrink-0"
    >
      <title>Chevron Right icon</title>
      <path
        d="M26.9853 11.7274C26.9287 11.0826 26.6401 10.4541 26.1307 9.96232C26.0401 9.87488 25.9439 9.79837 25.8477 9.72187L16.6451 0.836113C15.4905 -0.278704 13.6228 -0.278704 12.4626 0.836113C11.308 1.95093 11.308 3.75978 12.4626 4.87459L16.9054 9.16446H2.95435C1.32436 9.16446 0 10.4432 0 12.0171C0 13.5909 1.32436 14.8697 2.95435 14.8697H16.8602L12.4569 19.1213C11.3024 20.2361 11.3024 22.045 12.4569 23.1598C13.6115 24.2801 15.4849 24.2801 16.6394 23.1598L25.7854 14.3232C25.91 14.2358 26.0232 14.1429 26.1364 14.0391C26.7872 13.4051 27.0702 12.5526 26.9853 11.7274Z"
        fill={fill}
      />
    </svg>
  );
}
